<script>
import { createHOC } from 'vue-hoc'
import { queryUnitTree } from '@centit/api-admin/cp'
import { queryDepartmentUnit } from '@centit/api-admin/unit'
import { mapState } from 'vuex'
import { deepCopy } from '../utils'
import { TreeSelect } from '@centit/ui-form'
import Vue from 'vue'

const options = {
  name: 'UnitTreeSelect',

  props: {
    tag: {
      type: String,
      default: 'T',
    },

    department: Boolean,
    filterType: {
      type: String,
      default: '1',
    },
  },
  computed: {
    ...mapState([
      'unitInfo',
    ]),
  },
}

const renderWith = {
  props: {
    query() {
      const UnitMap = Vue.UnitMap
      const AllUnits = Vue.AllUnits

      switch (this.filterType) {
      case '0':
        return () => this.department ? queryDepartmentUnit() : queryUnitTree(this.tag)
      case '1':
        return () => {
          if (!this.unitInfo.parentUnit) {
            return AllUnits
          }

          const unit = deepCopy(UnitMap[this.unitInfo.parentUnit])

          return unit.children.map(m => {
            m.children = m.children.map(mm => {
              delete mm.children

              return mm
            })

            return m
          })
        }
      case '2':
        return () => {
          const unit = deepCopy(this.unitInfo)

          return unit.children.map(m => {
            delete m.children

            return m
          })
        }
      case '3':
        return () => this.unitInfo.parentUnit ? UnitMap[this.unitInfo.parentUnit].children : AllUnits
      }
    },
    valueField: 'unitCode',
    textField: 'unitName',
  },
}

export default createHOC(TreeSelect, options, renderWith)
</script>
